import { render, staticRenderFns } from "./WizardDialog.vue?vue&type=template&id=4890c713&scoped=true"
import script from "./WizardDialog.vue?vue&type=script&lang=js"
export * from "./WizardDialog.vue?vue&type=script&lang=js"
import style0 from "./WizardDialog.vue?vue&type=style&index=0&id=4890c713&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4890c713",
  null
  
)

export default component.exports